import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'

const ErrorLayout = compose(
  connect(state => {
    return {
      config: state.config
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.dispatch({
        type: 'SET_CONFIG',
        config: { layout: 'error-layout' }
      })
    }
  })
)

export default ErrorLayout
